import * as React from 'react'

import FeatureContainer from '../../../client/containers/feature'
import ExperimentsLoadingCover from '../../components/experimentsLoadingCover'
import experimentsConfig from '../../../config/experiments'
import ClassicTemplate from './templates/classicTemplate'
import RedesignedBlocksTemplate from './templates/redesignedBlocksTemplate'

import * as styles from './homePage.module.css'

import { Props } from '../../containers/homePageContainer/createHomePageContainer'

const HomePage = ({
  currentSite,
  location,
  isSignedIn,
  metadata,
  categories,
  blocks,
  blocksB,
  blocksC,
  blocksD,
  newestItemsData,
  featuredItems,
  freeItems,
  featuredAuthor,
  fetchNewestItemsByCategory,
  preferences,
  muteVideo,
  reportItemClick,
  makeSearchLink,
  experiments,
  experimentsReady,
  history,
  match
}: Props) => {
  return (
    <div className={styles.root}>
      <ExperimentsLoadingCover
        currentSite={currentSite}
        experimentsReady={experimentsReady}
        experimentsConfig={experimentsConfig}
      >
        <FeatureContainer name="!homepageNewDesign">
          <ClassicTemplate
            currentSite={currentSite}
            location={location}
            isSignedIn={isSignedIn}
            metadata={metadata}
            categories={categories}
            newestItemsData={newestItemsData}
            featuredItems={featuredItems}
            freeItems={freeItems}
            featuredAuthor={featuredAuthor}
            fetchNewestItemsByCategory={fetchNewestItemsByCategory}
            preferences={preferences}
            muteVideo={muteVideo}
            reportItemClick={reportItemClick}
            makeSearchLink={makeSearchLink}
            experiments={experiments}
            experimentsReady={experimentsReady}
            blocks={blocks}
            blocksB={blocksB}
            blocksC={blocksC}
            blocksD={blocksD}
          />
        </FeatureContainer>
        <FeatureContainer name="homepageNewDesign">
          <RedesignedBlocksTemplate
            history={history}
            match={match}
            currentSite={currentSite}
            location={location}
            isSignedIn={isSignedIn}
            metadata={metadata}
            categories={categories}
            newestItemsData={newestItemsData}
            featuredItems={featuredItems}
            freeItems={freeItems}
            featuredAuthor={featuredAuthor}
            fetchNewestItemsByCategory={fetchNewestItemsByCategory}
            preferences={preferences}
            muteVideo={muteVideo}
            reportItemClick={reportItemClick}
            makeSearchLink={makeSearchLink}
            experiments={experiments}
            experimentsReady={experimentsReady}
            blocks={blocks}
            blocksB={blocksB}
            blocksC={blocksC}
            blocksD={blocksD}
          />
        </FeatureContainer>
      </ExperimentsLoadingCover>
    </div>
  )
}

export default HomePage
